"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XHRBankIdPlugin = void 0;
class XHRBankIdPlugin {
    constructor(bankId) {
        this.name = this.constructor.name;
        this.bankId = bankId;
    }
    handleRequest(request) {
        //TODO configurable
        request.headers = Object.assign(Object.assign({}, request.headers), { bankId: this.bankId });
        return Promise.resolve(request);
    }
}
exports.XHRBankIdPlugin = XHRBankIdPlugin;
//# sourceMappingURL=xhrBankIdPlugin.js.map